module.exports = __webpack_public_path__ + "img/child-in-class.84ae87b6.webp";